var _circle, _path, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 45.5,
    r: 26.5,
    fill: "#FBE3E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.6667 13H14.8333C13.2862 13 11.8025 13.6146 10.7085 14.7085C9.61458 15.8025 9 17.2862 9 18.8333V45.0833C9 46.6304 9.61458 48.1142 10.7085 49.2081C11.8025 50.3021 13.2862 50.9167 14.8333 50.9167C16.3804 50.9167 17.8642 51.5312 18.9581 52.6252C20.0521 53.7192 20.6667 55.2029 20.6667 56.75V59.5792C20.6669 60.1238 20.8196 60.6576 21.1076 61.1199C21.3955 61.5822 21.8072 61.9547 22.2959 62.1951C22.7846 62.4356 23.3309 62.5343 23.8729 62.4803C24.4149 62.4262 24.9309 62.2214 25.3625 61.8892L38.05 52.1271C39.0701 51.3421 40.3212 50.9165 41.6083 50.9167H55.6667C57.2138 50.9167 58.6975 50.3021 59.7915 49.2081C60.8854 48.1142 61.5 46.6304 61.5 45.0833V18.8333C61.5 17.2862 60.8854 15.8025 59.7915 14.7085C58.6975 13.6146 57.2138 13 55.6667 13V13Z",
    stroke: "#710D0D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 13.5,
    r: 13.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0523 8.04801L53.9892 18.9619M53.0485 8.39237L62.9513 18.6075",
    stroke: "#710D0D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b478d008170a6dc18438736e77d409cd.svg";
export { ForwardRef as ReactComponent };